import React, { useState } from 'react';
import ProductMainHeading from '@components/molecules/products/product-main-heading/product-main-heading';
import ProductTags from '@components/molecules/products/product-tags/product-tags';
import ProductGallery from '@components/molecules/products/product-gallery/product-gallery';
import ProductDetails from '@components/molecules/products/product-details/product-details';
import ProductLikeButton from '@components/atoms/product-like-button/product-like-button';
import useProductQuery from '@hooks/product/use-product-query';
import clsx from 'clsx';
import styles from './pdp-top.module.scss';

const PdpTop: React.FC = () => {
  const { product } = useProductQuery();
  const [popUpVisible, setPopUpVisible] = useState<boolean>(false);

  return (
    <div className={styles.pdpTop}>
      <div className={styles.pdpTop__title}>
        <ProductMainHeading />
        <ProductTags product={product} />
      </div>
      <div className={styles.pdpTop__image}>
        <div
          className={clsx(
            popUpVisible && styles.pdpTop__image__like,
            popUpVisible && styles['pdpTop__image__like--visible'],
            !popUpVisible && styles.pdpTop__image__like,
          )}
        >
          <ProductLikeButton
            product={product}
            showText={false}
            onPopupVisibilityChange={setPopUpVisible}
            isFavorite
            pageType="product_page"
          />
        </div>

        <ProductGallery
          pictures={product?.pictures}
          productPath={product?.path}
          defaultAlt={`${product.name} ${product?.brand?.name}`}
        />
      </div>
      <div className={styles.pdpTop__infos}>
        <ProductDetails />
      </div>
    </div>
  );
};

export default PdpTop;
